<template>
  <div class="imgs" v-if="urls && urls.length">
    <el-image v-if="images && images.length" :src="images[0] + '?x-oss-process=style/thum_webp_h200'" :preview-src-list="images"></el-image>
    <template v-if="videos && videos.length">
      <video v-for="(url, idx) in videos" :key="idx" :src="url" muted @click="handlePreview(url)" />
    </template>
  </div>
</template>
<script>
export default {
  name: 'DeliveryAttachmentShower',
  props: {
    urls: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  computed: {
    images () {
      return this.urls.filter(u => !this.isVideo(u))
    },
    videos () {
      return this.urls.filter(u => this.isVideo(u))
    }
  },
  methods: {
    isVideo (attachment) {
      const url = new URL(attachment)
      let pathName = url.pathname
      if (pathName.endsWith('/')) {
        pathName = pathName.slice(0, pathName.length - 1)
      }
      if (pathName.endsWith('.mp4')) {
        return true
      }
      return false
    },
    handlePreview (url) {
      window.open(url, '__blank')
    }
  }
}
</script>
